import { Box, Button, Divider, Paper, Typography } from '@mui/material';
import MuiGrid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import { Link } from 'react-router-dom';
import { useResponsive } from '../../hooks/useResponsive';
import { Clickthrough } from '../Pager/Clickthrough';
import { PagerProvider } from '../Pager/PagerProvider';

const Grid = styled(MuiGrid)(({ theme }) => ({
  width: '100%',
  ...theme.typography.body2,
  '& [role="separator"]': {
    margin: theme.spacing(0, 2),
  },
}));

const Guide = () => {
  const { isMobile } = useResponsive();

  return (
    <>
      <Box sx={{ flexGrow: 1 }}>
        <Paper
          elevation={0}
          square
          sx={{
            backgroundColor: '#ECECEC',
          }}
        >
          <Grid sx={{ height: isMobile ? 'auto' : '700px' }} container>
            <Grid item xs>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  padding: isMobile ? '20px' : '64px',
                }}
              >
                <Box sx={{ paddingBottom: isMobile ? '16px' : '64px' }}>
                  <Typography color='primary' variant='h5'>
                    What to know before you start!
                  </Typography>
                </Box>

                <Typography>
                  Please use the following TLA Guide to help guide you through
                  where you need to go or who you need to contact for your
                  specific circumstances in regards to the current water issues.
                </Typography>
                <Box sx={{ paddingBottom: '20px' }}></Box>
                <Typography>
                  We know this may not cover everyones particular circumstance,
                  please know that we are working hard on getting the answers
                  for you as soon as we can!
                </Typography>
                <Box sx={{ paddingBottom: '20px' }}></Box>

                {isMobile ? (
                  <Button variant='contained'>
                    <Link
                      style={{ color: 'white', textDecoration: 'none' }}
                      to='/guide'
                    >
                      Start TLA Guide
                    </Link>
                  </Button>
                ) : null}
              </Box>
            </Grid>
            <Divider orientation='vertical' variant='middle' flexItem />
            {!isMobile ? (
              <Grid item xs>
                <Box sx={{ padding: '64px' }}>
                  <PagerProvider>
                    <Clickthrough />
                  </PagerProvider>
                </Box>
              </Grid>
            ) : null}
          </Grid>
        </Paper>
      </Box>
    </>
  );
};

export { Guide };
